import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    constructor(private router: Router) { }
    currentYear = new Date().getFullYear();

    ngOnInit(): void {
    }

    scrollToTop(): void {
        // Verificar si estamos en la página principal
        const isOnHomePage = this.router.url === '/' || this.router.url === '/home' || this.router.url.startsWith('/#');
        
        if (!isOnHomePage) {
            // Si no estamos en la página principal, navegar primero a la raíz
            this.router.navigate(['/']).then(() => {
                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 100);
            });
        } else {
            // Si ya estamos en la página principal, hacer scroll directamente
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    scrollToSection(sectionId: string): void {
        // Verificar si estamos en la página principal
        const isOnHomePage = this.router.url === '/' || this.router.url === '/home' || this.router.url.startsWith('/#');
        
        if (!isOnHomePage) {
            // Si no estamos en la página principal, navegar primero a la raíz con el fragmento
            this.router.navigate(['/'], { fragment: sectionId }).then(() => {
                // Esperar un momento para que la página cargue
                setTimeout(() => {
                    const element = document.getElementById(sectionId);
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 100);
            });
        } else {
            // Si ya estamos en la página principal, hacer scroll directamente
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }

    isOnSupportPage(): boolean {
        return this.router.url === '/course/support' || this.router.url.startsWith('/course/support');
    }

    copyrightText: Text[] = [
        {
            text: '© Nial is Proudly Owned by HiBootstrap'
        }
    ]

}
class Text {
    text : string;
}